import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Select,
  FormControl,
  InputLabel,
  Box
} from '@mui/material';
import { FaUserCircle } from 'react-icons/fa';
import Logout from 'components/Logout.js';
import axios from 'utils/axios';
import { useTranslation } from 'react-i18next';
import AuthService from 'services/AuthService';


const Navbar = () => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(AuthService.getLanguage());
  const [anchorEl, setAnchorEl] = useState(null);
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  // Replace with actual username (from context or props)
  const username = AuthService.getUsername() || 'User';
  const showIfTrue = true;

  const jezik = [
    { id: 1, name: 'Bosanski', code: 'bs' },
    { id: 2, name: 'Hrvatski', code: 'cr' },
    { id: 3, name: 'Srpski', code: 'sr' },
  ];

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  const handleSelectChange = async (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    try {
      const response = await axios.post('/users/language', { Id: value });
      if (response.status === 204) {
        const langCode = jezik.find((item) => item.id === parseInt(value))?.code;
        if (langCode) {
          handleLanguageChange(langCode);
          AuthService.setLanguage(value);
        }
      }
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleResetPassword = () => {
    handleClose();
    navigate('/reset-password');
  };


  return (
    <AppBar position="static" sx={{ backgroundColor: '#0a58ca' }}>
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to="/dashboard"
          sx={{
            color: 'white',
            textDecoration: 'none',
            flexGrow: 1,
            fontWeight: 600
          }}
        >
          ePisarnica
        </Typography>

        {showIfTrue && (
          <FormControl size="small" sx={{ mr: 2, minWidth: 150 }}>
            <InputLabel sx={{ color: 'white' }}>{t('language_selection')}</InputLabel>
            <Select
              native
              value={selectedValue}
              onChange={handleSelectChange}
              label={t('language_selection')}
              sx={{
                color: 'white',
                backgroundColor: '#1565c0',
                borderRadius: 1,
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#90caf9',
                },
                '& .MuiSvgIcon-root': {
                  color: 'white',
                }
              }}
              inputProps={{
                style: {
                  color: 'white',
                }
              }}
            >
              <option value="" style={{ backgroundColor: 'white', color: 'black' }}>
                {t('language_selection')}
              </option>
              {jezik.map((item) => (
                <option
                  key={item.id}
                  value={item.id}
                  style={{
                    backgroundColor: 'white',
                    color: 'black',
                  }}
                >
                  {item.name}
                </option>
              ))}
            </Select>
          </FormControl>
        )}

        <Box
          onClick={handleMenu}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: 'white',
            '&:hover': {
              opacity: 0.9
            }
          }}
        >
          <Typography variant="subtitle1" sx={{ mr: 1 }}>
            {username}
          </Typography>
          <FaUserCircle size={24} />
        </Box>


        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          MenuListProps={{
            sx: {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <MenuItem
            onClick={handleResetPassword}
            sx={{
              '&:hover': {
                backgroundColor: '#e3f2fd',
                color: '#0a58ca',
              },
            }}
          >
            {t('reset_password')}
          </MenuItem>
          {/* <MenuItem
            onClick={handleLogout}
            sx={{
              '&:hover': {
                backgroundColor: '#e3f2fd',
                color: '#0a58ca',
              },
            }}
          >
            Logout
          </MenuItem> */}
          <Logout></Logout>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
